import { jwtDecode } from 'jwt-decode';

interface DadosToken {
  Id: string;
  Nome: string;
  CPF: string;
  IdPerfil: string;
  Perfil: string;
  IdInstituicao: string;
  Instituicao: string;
  IdMunicipio: string;
  Municipio: string;
  TipoInstituicao: string;
  Claims: string;
  exp: number;
  iss: string;
}

export class TokenService {
  static ObterTokenDecodificado(): DadosToken | null {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
      return jwtDecode<DadosToken>(token);
    } catch {
      return null;
    }
  }

  static ObterNomeUsuario(): string {
    const token = this.ObterTokenDecodificado();
    return token?.Nome ?? '';
  }

  static ObterInstituicaoUsuario(): { id: string; nome: string, idMunicipio: string, municipio: string, tipoInstituicao: string } {
    const token = this.ObterTokenDecodificado();
    return {
      id: token?.IdInstituicao ?? '',
      nome: token?.Instituicao ?? '',
      idMunicipio: token?.IdMunicipio ?? '',
      municipio: token?.Municipio ?? '',
      tipoInstituicao: token?.TipoInstituicao ?? '',
    };
  }

  static ObterPerfil(): string {
    const token = this.ObterTokenDecodificado();
    return token?.CPF ?? '';
  }

  static ObterPermissoes(): Record<string, string[]> {
    const token = this.ObterTokenDecodificado();
    if (!token || !token.Claims) return {};
    try {
      return JSON.parse(token.Claims);
    } catch {
      return {};
    }
  }

  static PossuiPermissao(moduloId: string, permissaoId?: string): boolean {
    const permissoes = this.ObterPermissoes();
    if (!moduloId) return false;
    const moduloKey = Object.keys(permissoes).find(m => m.toLowerCase() == moduloId.toLowerCase());

    if (!moduloKey) return false;
    if (!permissaoId) return true;

    return permissoes[moduloKey].some(p => p.toLowerCase() == permissaoId.toLowerCase());
  }

  static PossuiPermissaoGlobal(permissaoId: string): boolean {
    const permissoes = this.ObterPermissoes();
    return Object.values(permissoes).flat().some(p => p.toLowerCase() == permissaoId.toLowerCase());
  }

  static PossuiFuncionalidade(modulo: string, funcionalidade?: string): boolean {
    const permissoes = this.ObterPermissoes();
    const moduloKey = Object.keys(permissoes).find(m => m.toLowerCase() == modulo.toLowerCase());

    if (!moduloKey) return false;
    if (!funcionalidade) return true;
    return permissoes[moduloKey].some(p => p.toLowerCase() == funcionalidade.toLowerCase());
  }

  static ExibirMenu(moduloId?: string): boolean {
    if (!moduloId) return false;
    const permissoes = this.ObterPermissoes();
    const moduloKey = Object.keys(permissoes).find(m => m.toLowerCase() == moduloId.toLowerCase());
    return !!moduloKey;
  }

  static TokenExpirado(): boolean {
    const token = this.ObterTokenDecodificado();
    if (!token) return true;

    const agora = Math.floor(Date.now() / 1000);
    return token.exp < agora;
  }

  static LogoutForcado() {
    localStorage.clear();
    sessionStorage.clear();
  }

  static PodeVerTodasUnidades(modulo: string): boolean {
    return this.PossuiFuncionalidade(modulo, 'Ver todas as Unidades');
  }

  static PodeVerSomenteUnidadeCadastro(modulo: string): boolean {
    return this.PossuiFuncionalidade(modulo, 'Ver apenas unidade de cadastro');
  }

  static NivelAcessoUnidade(modulo: string): 'todas' | 'cadastro' | 'nenhum' {
    const todas = this.PodeVerTodasUnidades(modulo);
    const cadastro = this.PodeVerSomenteUnidadeCadastro(modulo);

    if (todas) return 'todas';
    if (cadastro) return 'cadastro';
    return 'nenhum';
  }
}
